export const getSearchSubstring = (search?: string, url?: string): string => {
  if (search) return search

  // If !search but url is provided, extract the search portion
  if (url) {
    try {
      return new URL(url).search
    } catch (ignore) {
      const questionMarkIndex = url.indexOf('?')
      if (questionMarkIndex !== -1) {
        return url.substring(questionMarkIndex)
      }
    }
  }

  // Return empty string if no search found
  return ''
}
